module.exports = __webpack_public_path__ + "media/images/shop/photo_large-004a23cc94a8c6c187b3e4c6cec986dc.jpg";